if (!customElements.get("blog-slider")) {
  customElements.define(
    "blog-slider",
    class BlogSlider extends HTMLElement {
      constructor() {
        super();

        // this.updateActivePage(); // Added to show page buttons if manual results are less than a page long (before Klevu results load)

        this.cardSpacing = 20;

        this.buttonContainer = this.querySelector("[data-button-container]");
        this.navButtons = this.buttonContainer.querySelectorAll("button");
        this.currentPageElement = this.querySelector(
          ".slider-counter--current",
        );
        this.pageTotalElement = this.querySelector(".slider-counter--total");

        this.carousel = this.querySelector("[data-blog-carousel]");

        this.observer = new MutationObserver(() => {
          this.onArticlesChanged();
        });

        this.observer.observe(this.carousel, {
          childList: true,
          subtree: true,
        });

        let style = getComputedStyle(this.carousel);
        let spacingProperty = style.getPropertyValue("--spacing");
        this.cardSpacing = parseInt(spacingProperty);

        this.scrollTicking = false;
        this.index = 0;
        // this.maxIndex = this.articleCardCount - 1;

        this.carousel.addEventListener("scroll", this.handleScroll.bind(this));

        this.navButtons.forEach((navButton) => {
          navButton.addEventListener("click", (e) => {
            e.preventDefault();
            let moveBy = parseInt(navButton.dataset.move);
            this.moveCarousel(moveBy);
          });
        });

        window.addEventListener("resize", this.handleWindowResize.bind(this));
      }
      get maxIndex() {
        return this._maxIndex;
      }
      set maxIndex(maxIndex) {
        this._maxIndex = maxIndex;
      }
      get articleCardCount() {
        // console.log("THIS: ", this.articleCards);
        return this.articleCards.length;
      }
      get articleCards() {
        return this.carousel.querySelectorAll(".blog__post");
      }
      moveCarousel(moveBy) {
        let cardsPerPage = this.getCardsPerPage();
        let totalPages = Math.ceil(this.articleCardCount / cardsPerPage);

        // Determine current page — if at maxIndex, we're on the last page
        let currentPage;
        if (this.index >= this.maxIndex) {
          currentPage = totalPages - 1;
        } else {
          currentPage = Math.round(this.index / cardsPerPage);
        }

        let targetPage = Math.min(
          Math.max(currentPage + moveBy, 0),
          totalPages - 1,
        );

        // Last page snaps to maxIndex so the final cards are visible
        if (targetPage === totalPages - 1) {
          this.index = this.maxIndex;
        } else {
          this.index = targetPage * cardsPerPage;
        }

        this.carousel.scrollLeft = this.index * this.cardWidth;
      }
      getCardsPerPage() {
        let style = getComputedStyle(this.carousel);
        let cardsPerPageProperty = style.getPropertyValue("--cards-per-page");
        let cardsPerPage = parseInt(cardsPerPageProperty);
        return cardsPerPage || 1;
      }
      handleScroll(e) {
        if (!this.scrollTicking) {
          window.requestAnimationFrame(() => {
            this.updateActivePage();
            this.scrollTicking = false;
          });
          this.scrollTicking = true;
        }
      }
      updateActivePage() {
        this.calculateCardWidth();
        this.index = Math.round(this.carousel.scrollLeft / this.cardWidth);

        this.navButtons.forEach((button) => button.removeAttribute("disabled"));

        if (this.index < 1) {
          this.querySelector('button[data-move="-1"').setAttribute(
            "disabled",
            true,
          );
        } else if (this.index == this.maxIndex) {
          this.querySelector('button[data-move="1"').setAttribute(
            "disabled",
            true,
          );
        }

        let cardsPerPage = this.getCardsPerPage();
        if (cardsPerPage >= this.articleCards.length) {
          this.navButtons.forEach((button) => button.classList.add("hidden"));
        } else {
          this.navButtons.forEach((button) =>
            button.classList.remove("hidden"),
          );
        }

        // Update counter - show page numbers instead of card numbers
        if (this.currentPageElement && this.pageTotalElement) {
          let totalPages = Math.ceil(this.articleCards.length / cardsPerPage);
          let currentPage;
          if (this.index >= this.maxIndex) {
            currentPage = totalPages;
          } else {
            currentPage = Math.floor(this.index / cardsPerPage) + 1;
          }
          this.currentPageElement.textContent = currentPage;
          this.pageTotalElement.textContent = totalPages;

          const counterContainer =
            this.currentPageElement.closest(".slider-counter");

          if (totalPages <= 1) {
            counterContainer?.classList.add("hidden");
          } else {
            counterContainer?.classList.remove("hidden");
          }
        }
      }
      calculateCardWidth() {
        this.cardWidth =
          this.articleCards[0]?.getBoundingClientRect().width +
            this.cardSpacing || 0;
      }
      calculateMaxIndex() {
        let perScreen = Math.max(
          1,
          Math.ceil(
            this.carousel.getBoundingClientRect().width / this.cardWidth,
          ),
        );

        if (perScreen <= 1) {
          this.maxIndex = this.articleCardCount - 1;
        } else {
          this.maxIndex = this.articleCardCount - perScreen;
        }
      }
      handleWindowResize() {
        this.calculateCardWidth();
        this.calculateMaxIndex();
        this.updateActivePage();
      }
      onArticlesChanged() {
        if (this.articleCards.length === 0) return;
        this.calculateCardWidth();
        this.calculateMaxIndex();
        this.updateActivePage();
      }
      init() {
        this.calculateCardWidth();
        this.calculateMaxIndex();
        this.updateActivePage();
      }
      connectedCallback() {
        if (this.articleCards.length > 0) {
          // console.log(this.articleCards.length);
          this.init();
        }
      }
    },
  );
}